export default __webpack_public_path__ + "media/vue/img/whence/zoom-icon-e6b8f9770e5388df0ebe5a9a539f25f2.png";